/* ─────────────────────────────────────────────────────────────
   lala / product-form.js
   Variant selection, quantity, add-to-cart with AJAX.
   Delegates photo upload / message UI to personalization.js.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var LA = window.lala = window.lala || {};

  function init() {
    document.querySelectorAll('[data-product-form]').forEach(initForm);
  }

  function initForm(form) {
    var data = null;
    try { data = JSON.parse(form.dataset.product); } catch (e) { return; }
    if (!data) return;

    var priceEl = document.querySelector('[data-price-for="' + data.id + '"]');
    var variantTitleEl = document.querySelector('[data-variant-title-for="' + data.id + '"]');
    var stockEl = document.querySelector('[data-stock-for="' + data.id + '"]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var submitPrice = submitBtn && submitBtn.querySelector('[data-btn-price]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyDec = form.querySelector('[data-qty-dec]');
    var qtyInc = form.querySelector('[data-qty-inc]');
    var variantInput = form.querySelector('[name="id"]');
    var optionInputs = form.querySelectorAll('[data-option-input]');

    // Quantity controls
    var setQty = function (v) {
      v = Math.max(1, parseInt(v, 10) || 1);
      if (qtyInput) qtyInput.value = v;
    };
    qtyDec && qtyDec.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
    qtyInc && qtyInc.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
    qtyInput && qtyInput.addEventListener('input', function () { setQty(qtyInput.value); });

    // Variant selection
    function currentOptions() {
      var opts = [];
      optionInputs.forEach(function (group) {
        var sel = group.querySelector('input:checked');
        if (sel) opts[parseInt(group.dataset.optionIdx, 10)] = sel.value;
      });
      return opts;
    }
    function findVariant(opts) {
      // Single-variant product — just return the only variant
      if (!opts.length) return data.variants[0];
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function updateVariant() {
      var opts = currentOptions();
      var v = findVariant(opts);
      if (!v) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.querySelector('[data-btn-label]').textContent = submitBtn.dataset.labelUnavailable || 'Unavailable';
          if (submitPrice) submitPrice.textContent = '';
        }
        return;
      }
      if (variantInput) variantInput.value = v.id;
      // URL sync (shallow)
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      // Price
      if (priceEl) {
        priceEl.innerHTML =
          (v.compare_at_price && v.compare_at_price > v.price ? '<span class="la-price__was">' + LA.money(v.compare_at_price) + '</span>' : '') +
          '<b>' + LA.money(v.price) + '</b>';
      }
      if (submitPrice) submitPrice.textContent = LA.money(v.price);
      if (variantTitleEl) variantTitleEl.textContent = '· ' + v.title;
      // Stock / availability
      if (submitBtn) {
        if (v.available) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.querySelector('[data-btn-label]').textContent = submitBtn.dataset.labelAdd || 'Add to cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.querySelector('[data-btn-label]').textContent = submitBtn.dataset.labelSoldOut || 'Sold out';
        }
      }
      if (stockEl) {
        if (!v.available) { stockEl.className = 'la-stock la-stock--out'; stockEl.textContent = stockEl.dataset.labelOut || 'Out of stock'; }
        else if (v.inventory_quantity && v.inventory_quantity > 0 && v.inventory_quantity <= 3) { stockEl.className = 'la-stock'; stockEl.textContent = (stockEl.dataset.labelLow || '%count% left').replace('%count%', v.inventory_quantity); }
        else { stockEl.className = 'la-stock la-stock--muted'; stockEl.textContent = stockEl.dataset.labelAvail || 'In stock'; }
      }
      LA.emit('variant:change', { variant: v, product: data });
    }
    optionInputs.forEach(function (group) {
      group.querySelectorAll('input').forEach(function (i) { i.addEventListener('change', updateVariant); });
    });
    updateVariant();

    // Terms & conditions — clear error state on check
    var tcInput = form.querySelector('[data-tc-input]');
    var tcEl = form.querySelector('[data-tc]');
    if (tcInput && tcEl) {
      tcInput.addEventListener('change', function () {
        if (tcInput.checked) tcEl.classList.remove('is-error');
      });
    }

    // Submit — AJAX
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn && submitBtn.disabled) return;

      // Terms & conditions gate
      if (tcInput && !tcInput.checked) {
        tcEl && tcEl.classList.add('is-error');
        if (submitBtn) {
          submitBtn.classList.remove('la-shake');
          // Force reflow so the animation restarts on repeat clicks
          void submitBtn.offsetWidth;
          submitBtn.classList.add('la-shake');
          setTimeout(function () { submitBtn.classList.remove('la-shake'); }, 600);
        }
        tcEl && tcEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Give personalization a chance to validate
      var personalOk = true;
      var personalEvent = new CustomEvent('lala:product:validate', { cancelable: true, detail: { form: form } });
      document.dispatchEvent(personalEvent);
      if (personalEvent.defaultPrevented) return;

      if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.disabled = true; }
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      }).then(function (r) { return r.json().then(function (d) { return r.ok ? d : Promise.reject(d); }); })
        .then(function () { return LA.fetchJSON('/cart.js'); })
        .then(function (cart) {
          LA.emit('cart:added', { cart: cart, form: form });
          LA.flash(form.dataset.addedFlash || 'Added to cart');
        })
        .catch(function (err) {
          console.error('[lala] add to cart failed', err);
          LA.flash((err && err.description) || (err && err.message) || 'Sorry, something went wrong.');
        })
        .then(function () {
          if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.disabled = false; }
        });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
